import { ValidatedInput } from '@idm/ui-components';

const { Rule } = ValidatedInput;

export { Rule as default };
